import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";

import { observer } from "mobx-react";
import UserStore from "../stores/UserStore";

const fakeAuth = {
  isAuthenticated: false
};

const PrivateRoute = observer(({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      UserStore.hasUser() === true ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      )
    }
  />
));

export default PrivateRoute;
